<!-- 车辆通行授权页面 -->
<template>
  <div class="authorization-container tree-line-style">
    <!--主页面 -->
    <div class="flex-row" style="height: 100%">
      <!-- 左侧树 -->
      <div class="section-mian_left">
        <el-scrollbar
          class="flex-auto"
          style="margin-top: 10px; height: calc(100% - 40px)"
        >
          <el-tree
            ref="leftTree"
            :data="frame"
            :props="treeProps"
            class="gate-box"
            @node-click="treeNodeClick"
            :expand-on-click-node="false"
            :default-expand-all="false"
            :default-expanded-keys="expandedKeys"
            :highlight-current="true"
            node-key="thirdDeviceId"
          >
            <template slot-scope="{ node }">
              <element-tree-line
                :node="node"
                :showLabelLine="true"
                :indent="16"
                class="tree-line"
              >
                <span class="custom-tree-node">
                  <span :title="node.label" class="view-label">{{
                    node.label
                  }}</span>
                </span>
              </element-tree-line>
            </template>
          </el-tree>
        </el-scrollbar>
      </div>

      <!-- 右侧tab栏 -->
      <div class="section-mian_right">
        <ioc-tab-group
          ref="tabs"
          v-if="false"
          :option="tabOption"
          @change="handleChange"
        ></ioc-tab-group>
        <!-- 头部按钮 -->
        <div class="section-mian__toolbar flex-row" v-if="isRoot">
          <el-button
            type="primary"
            size="small"
            class="iss-operation-button"
            v-auth="'/carAuthorization/index:add'"
            @click="openAuthorizationDialog"
          >
            授权
          </el-button>
          <!-- 废弃此功能 -->
          <!-- <el-button type="primary"
                     size="small"
                     class="iss-operation-button"
                     @click="removeAuthorization">
            移除授权
          </el-button> -->
          <el-button
            type="primary"
            size="small"
            class="iss-operation-button"
            v-auth="'/carAuthorization/index:sync'"
            @click="syncAuthorization"
          >
            授权信息同步
          </el-button>
          <el-button
            type="primary"
            size="small"
            class="iss-operation-button"
            :disabled="disabled"
            v-auth="'/carAuthorization/index:export'"
            @click="exportDocument"
          >
            导出
          </el-button>
          <span class="export-tips" v-show="disabled">正在导出</span>
        </div>

        <!-- 右侧表格 -->
        <div class="section-main_table">
          <ioc-table
            ref="accessTab"
            :data="tableData"
            :option="tableOption"
            :page="page"
            @row-update="handleUpdate"
            @search-change="searchResult"
            @search-reset="resetQuery"
            @current-change="selectPage"
            @selection-change="selectionChange"
            @size-change="changeSize"
          >
            <!-- 表格按钮 自定义 -->
            <template slot="menu" slot-scope="scope">
              <!-- 取消授权和恢复授权功能废弃 -->
              <!-- <el-tooltip class="item"
                          effect="dark"
                          content="恢复授权"
                          placement="top"
                          popper-class="tooltip-draw">
                <el-button type="text"
                           icon="iconfont-lunan icon-lunan-shouquan"
                           @click="restoreAuthorization(scope.row)"
                           v-if="scope.row.authStatus === '失效'"></el-button>
              </el-tooltip>
              <el-tooltip class="item"
                          effect="dark"
                          content="取消授权"
                          placement="top"
                          popper-class="tooltip-draw">
                <el-button type="text"
                           icon="iconfont-lunan icon-lunan-weishouquan"
                           v-if="scope.row.authStatus === '已授权'"
                           @click="cancleAuthorization(scope.row)"></el-button>
              </el-tooltip> -->
              <el-tooltip
                class="item"
                effect="dark"
                content="修改"
                placement="top"
                v-auth="'/carAuthorization/index:add'"
                popper-class="tooltip-draw"
              >
                <el-button
                  type="text"
                  icon="iconfont icon-xiugai"
                  :disabled="scope.row.authStatus === '已授权'"
                  @click="handleEdit(scope.row, scope.index)"
                ></el-button>
              </el-tooltip>
              <el-tooltip
                class="item"
                effect="dark"
                content="详情"
                placement="top"
                popper-class="tooltip-draw"
              >
                <el-button
                  type="text"
                  icon="iconfont icon-Detail"
                  @click="handleView(scope.row, scope.index)"
                ></el-button>
              </el-tooltip>
            </template>
            <!-- 表格列 自定义 -->
            <!-- 未授权灰色 已授权高亮展示 -->
            <template slot="authStatus" slot-scope="scope">
              <span
                v-if="scope.row.authStatus === '失效'"
                style="color: #9b9b9b; cursor: pointer"
                @click="handleView(scope.row, scope.index)"
                >{{ scope.row.authStatus }}</span
              >
              <span
                v-else
                style="color: #00e8bb; cursor: pointer"
                @click="handleView(scope.row, scope.index)"
                >{{ scope.row.authStatus }}</span
              >
            </template>
            <!-- 详情页面中的授权信息列表 -->
            <template slot="viewFormSet">
              <h4 class="info-title">授权信息</h4>
              <ioc-table
                ref="crud"
                :data="detailData"
                :option="detailoption"
                :page="recordPage"
                @current-change="selectRecordPage"
                @size-change="changeRecordSize"
                class="table-box"
              >
                <!-- 失效红色色 已授权高亮展示 -->
                <template slot="authStatus" slot-scope="scope">
                  <span
                    v-if="scope.row.authStatus === '失效'"
                    style="color: red"
                    >{{ scope.row.authStatus }}</span
                  >
                  <span v-else style="color: #00e8bb">{{
                    scope.row.authStatus
                  }}</span>
                </template>
              </ioc-table>
            </template>
          </ioc-table>
        </div>
      </div>
    </div>
    <!-- 车辆选择弹框 -->
    <authority-dialog
      ref="authorization"
      @refreshList="getList"
      :treeData="gateOptions"
    ></authority-dialog>
  </div>
</template>
<script>
import { api } from "../api/index";
import utils from "@src/common/utils";
import { Dic, Bus, Dates } from "$utils";
import i18n from "@src/common/lib/i18n";
import { tableOption } from "../config/table";
import detailoption from "../config/detailOptions";
import authorityDialog from "../components/authorityDialog";
import ElementTreeLine from "element-tree-line";
export default {
  components: {
    authorityDialog,
    ElementTreeLine
  },
  data() {
    return {
      tabOption: {
        column: [
          {
            label: "车辆通行授权",
            prop: "car",
            typeId: "1"
          }
        ]
      },
      tableOption: tableOption(true, true),
      detailoption: detailoption(),
      // 分页属性设置
      page: {
        currentPage: 1,
        total: 10,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10
      },
      recordPage: {
        pageNum: 1,
        total: 0,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10
      },
      tableData: [],
      searchParams: {},
      // 选择的车辆code
      checkAuthCodes: [],
      isRoot: false,
      // 树的props
      treeProps: {
        children: "subDeviceInfoList",
        label: "thirdDeviceName",
        isLeaf: "parentDeviceId"
      },
      // 设备树的数据
      frame: [
        {
          thirdDeviceName: "车辆道闸",
          subDeviceInfoList: [],
          parentDeviceId: "200000006",
          parentDeviceIds: "200000006",
          systemId: "200000006",
          deviceID: "200000006"
        }
      ],
      thirdDeviceId: "",
      // 默认展开的节点的 key 的数组
      expandedKeys: [],
      gateOptions: [],
      detailData: [],
      currentCode: "",
      // 导出按钮是否禁用
      disabled: false
    };
  },
  created() {
    this.getAccessDeviceInfoTree();
  },
  mounted() {
    // 请求树根节点
  },
  methods: {
    // 获得车辆闸机树的数据
    getAccessDeviceInfoTree() {
      const params = {
        deviceType: "17"
      };
      // 闸机接口
      this.$fetch(api.device.getGateTree, params).then((res) => {
        if (res.success) {
          // this.frame = res.returnObj;
          // this.thirdDeviceId = this.frame[0].thirdDeviceId;
          // this.expandedKeys = [this.frame[0].thirdDeviceId];
          this.gateOptions = res.returnObj;
          this.frame[0].subDeviceInfoList = res.returnObj;
          this.thirdDeviceId = this.frame[0].subDeviceInfoList[0].thirdDeviceId;
          this.expandedKeys = [
            this.frame[0].subDeviceInfoList[0].thirdDeviceId
          ];
          this.$nextTick(function () {
            // 设置默认高亮的节点
            this.$refs.leftTree.setCurrentKey(this.thirdDeviceId);
            this.getList();
          });
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    //递归树结构
    menusDataPro(data) {
      const self = this;
      const result = [];
      if (data !== null) {
        data.forEach(function (item) {
          const entity = {};
          entity.id = item.areaDevGroupCode;
          entity.name = item.areaDevGroupName;
          entity.lng = item.lng;
          entity.lat = item.lat;
          entity.desc = item.desc;
          entity.parentCode = item.parentCode;
          entity.personList = [].concat(item.ownerList);
          entity.ownerList = self.showOwnerList(item.ownerList);
          entity.isLeaf = !item.hasLeaf || !item.childrens;
          if (item.childrens) {
            entity.children = self.menusDataPro(item.childrens);
          }
          result.push(entity);
        });
        return result;
      }
    },
    //导出
    exportDocument() {
      this.fetchDownLoadFile();
    },
    fetchDownLoadFile() {
      const params = {};
      params.thirdDeviceId = this.thirdDeviceId;
      params.plateCode = this.searchParams.plateCode;
      params.name = this.searchParams.name;
      params.personnelType = this.searchParams.personnelType;
      if (
        this.searchParams.passageTime &&
        this.searchParams.passageTime.length
      ) {
        params.effectiveTime = this.searchParams.passageTime[0]
          ? Dates.dayjs(this.searchParams.passageTime[0]).format(
              "YYYY-MM-DD HH:mm:ss"
            )
          : "";
        params.expirationTime = this.searchParams.passageTime[1]
          ? Dates.dayjs(this.searchParams.passageTime[1]).format(
              "YYYY-MM-DD HH:mm:ss"
            )
          : "";
      }
      // 兼容IE
      this.disabled = true;
      this.$fetchDownLoad(api.vehicle.exportAuthorityList, params, {
        responseType: "arraybuffer"
      }).then((response) => {
        const content = response.data;
        const blob = new Blob([content], { type: "application/zip" });
        const fileName =
          "车辆授权信息" +
          Dates.format(Date.now(), "yyyyMMddHHmmssms") +
          ".zip";
        if ("download" in document.createElement("a")) {
          // 非IE下载
          const elink = document.createElement("a");
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href); // 释放URL 对象
          document.body.removeChild(elink);
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, fileName);
        }
        this.disabled = false;
      });
    },
    showOwnerList(list) {
      return list.map((item) => item.personnelName).join(",");
    },
    // 树的子节点点击事件
    treeNodeClick(data, node) {
      // 只有第一级节点才可点击查询数据
      if (node.level === 2) {
        this.thirdDeviceId = data.thirdDeviceId;
        // 点击树节点后 查询列表
        this.getList();
      } else if (node.level === 1) {
        this.thirdDeviceId = "";
        this.getList();
      }
      if (node.level === 1) {
        // 只有根节点才展示授权按钮
        this.isRoot = true;
      } else {
        this.isRoot = false;
      }
    },

    // 切换选项卡
    handleChange(column) {
      this.tableOption = tableOption(true, true);
      this.getList();
    },
    // 获取列表
    getList() {
      const params = {};
      params.thirdDeviceId = this.thirdDeviceId;
      params.plateCode = this.searchParams.plateCode;
      params.name = this.searchParams.name;
      params.personnelType = this.searchParams.personnelType;
      params.pageNum = this.page.currentPage;
      params.pageSize = this.page.pageSize;
      if (
        this.searchParams.passageTime &&
        this.searchParams.passageTime.length
      ) {
        params.effectiveTime = this.searchParams.passageTime[0]
          ? Dates.dayjs(this.searchParams.passageTime[0]).format(
              "YYYY-MM-DD HH:mm:ss"
            )
          : "";
        params.expirationTime = this.searchParams.passageTime[1]
          ? Dates.dayjs(this.searchParams.passageTime[1]).format(
              "YYYY-MM-DD HH:mm:ss"
            )
          : "";
      }

      const loading = this.$loading({
        lock: true,
        text: "请求中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      this.$fetch(api.vehicle.getAuthorityList, params).then((response) => {
        setTimeout(() => {
          loading.close();
        }, 500);

        if (!response.success) {
          this.$message.error(response.msgContent);
          return;
        }
        response.returnObj.list.forEach((item) => {
          if (item.authStatus === "2") {
            item.authStatus = "失效";
          } else {
            item.authStatus = "已授权";
          }
        });
        this.tableData = response.returnObj
          ? Object.freeze([...response.returnObj.list])
          : [];
        this.page.total = response.returnObj ? response.returnObj.total : 0;
        this.$refs.accessTab.selectClear();
      });
    },
    // 授权按钮
    openAuthorizationDialog() {
      this.$refs.authorization.open(this.thirdDeviceId);
    },
    // 移除授权按钮
    removeAuthorization() {
      if (this.checkAuthCodes.length === 0) {
        this.$message({
          type: "warning",
          duration: 2000,
          message: "请选择你要移除授权的车辆"
        });
        return;
      }
      this.$confirm("您确定移除以下车辆的授权吗?", "确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let params = {
          // thirdDeviceId: this.thirdDeviceId, //闸机的第三方设备ID
          // cmdType: "2",
          // authStatus: "2",
          authCodeList: this.checkAuthCodes
        };
        // 调用移除授权的接口
        this.$fetch(api.vehicle.deleteCarAuthority, params).then((response) => {
          if (!response.success) {
            this.$message.error(response.msgContent);
            return;
          } else {
            this.$message.success(response.msgContent);
            this.getList();
          }
        });
      });
    },
    // 同步授权信息按钮
    syncAuthorization() {
      this.$confirm("您确定要同步授权信息吗?", "确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        // 调用同步授权的接口
        this.$fetch(api.vehicle.syncAuthorityList).then((res) => {
          if (res.success) {
            this.$message.success("同步成功");
            this.getList();
          } else {
            if (res.msgCode === "103009299010001") {
              this.$message.success(res.msgContent);
            } else {
              this.$message.error(res.msgContent);
            }
          }
        });
      });
    },

    handleEdit(row, index) {
      this.$nextTick(() => {
        this.$refs.accessTab.rowEdit(row, index);
      });
    },
    handleUpdate(updateInfo, done) {
      let params = {
        authCode: updateInfo.authCode,
        effectiveTime: updateInfo.effectiveTime
          ? Dates.dayjs(updateInfo.effectiveTime).format("YYYY-MM-DD HH:mm:ss")
          : "",
        expirationTime: updateInfo.expirationTime
          ? Dates.dayjs(updateInfo.expirationTime).format("YYYY-MM-DD HH:mm:ss")
          : ""
      };
      // 调用授权的接口
      this.$fetch(api.vehicle.updateAuthority, params).then((response) => {
        if (!response.success) {
          this.$message.error(response.msgContent);
          return;
        } else {
          this.$message.success(response.msgContent);
          this.getList();
          done();
        }
      });
    },
    // 取消授权按钮
    cancleAuthorization(row) {
      this.$confirm("您确定取消该车辆的授权么?", "确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let params = {
          // thirdDeviceId: this.thirdDeviceId, //闸机的第三方设备ID
          // plateCodeList: [row.plateCode],
          // cmdType: "2",
          authStatus: "2",
          authCode: row.authCode
        };
        // 调用授权的接口
        this.$fetch(api.vehicle.updateAuthority, params).then((response) => {
          if (!response.success) {
            this.$message.error(response.msgContent);
            return;
          } else {
            this.$message.success(response.msgContent);
            this.getList();
          }
        });
      });
    },
    // 恢复授权按钮
    restoreAuthorization(row) {
      this.$confirm("您确定恢复该车辆的授权么?", "确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        // let params = {
        //   thirdDeviceId: this.thirdDeviceId, //闸机的第三方设备ID
        //   plateCodeList: [row.plateCode],
        //   cmdType: "2",
        //   authStatus: "1",
        //   effectiveTime: row.effectiveTime,
        //   expirationTime: row.expirationTime,
        // };

        let params = {
          authCode: row.authCode,
          authStatus: "1",
          effectiveTime: row.effectiveTime,
          expirationTime: row.expirationTime
        };
        // 调用授权的接口
        this.$fetch(api.vehicle.updateAuthority, params).then((response) => {
          if (!response.success) {
            this.$message.error(response.msgContent);
            return;
          } else {
            this.$message.success(response.msgContent);
            this.getList();
          }
        });
      });
    },

    handleView(row, index) {
      this.$refs.accessTab.rowView(row, index);
      this.currentCode = row.authCode;
      this.$nextTick(() => {
        this.getDetailData(this.currentCode);
      });
    },
    // 查询按钮事件
    searchResult(param) {
      this.searchParams = Object.assign(param);
      this.getList();
    },
    // 重置按钮
    resetQuery() {
      this.getList();
    },

    // 当选择项发生变化时会触发该事件
    selectionChange(items) {
      this.checkAuthCodes = items.map((item) => {
        return item.authcode;
      });
    },
    // 点击上一页下一页按钮
    selectPage(val) {
      this.page.currentPage = val;
      this.getList();
    },
    // 修改每页数据数量
    changeSize(val) {
      this.page.currentPage = 1;
      this.page.pageSize = val;
      this.getList();
    },
    getDetailData(code) {
      let params = {
        authCode: code,
        pageNum: this.recordPage.pageNum,
        pageSize: this.recordPage.pageSize
      };
      // 调用授权的接口
      this.$fetch(api.vehicle.getRecordList, params).then((response) => {
        if (!response.success) {
          this.$message.error(response.msgContent);
          return;
        }
        response.returnObj.list.forEach((item) => {
          if (item.authStatus === "2") {
            item.authStatus = "失效";
          } else {
            item.authStatus = "已授权";
          }
        });
        this.detailData = response.returnObj
          ? Object.freeze([...response.returnObj.list])
          : [];
        this.recordPage.total = response.returnObj
          ? response.returnObj.total
          : 0;
      });
    },
    selectRecordPage(val) {
      this.recordPage.pageNum = val;
      this.getDetailData(this.currentCode);
    },
    changeRecordSize(val) {
      this.recordPage.pageNum = 1;
      this.recordPage.pageSize = val;
      this.getDetailData(this.currentCode);
    }
  }
};
</script>
<style lang="scss">
.authorization-container {
  width: 100%;
  height: 100%;
  .el-table__fixed-right-patch {
    display: none;
  }
  .el-dialog {
    .el-date-editor.el-input,
    .el-date-editor.el-input__inner {
      width: 200px;
    }
    .el-form-item--small .el-form-item__content {
      .el-input {
        width: 200px;
      }
    }
  }
  .export-tips {
    margin-left: 5px;
    color: red;
    vertical-align: middle;
  }
}
</style>
